import SearchBox from '@/modules/Search/components/SearchBox'
import { useTranslation } from 'react-i18next'

const Search = () => {
    const { t } = useTranslation()

    return (
        <>
            <div className="flex-1 md:block hidden max-w-[600px]">
                <SearchBox
                    placeholder={[
                        t('search-placeholder'),
                        t('search-by-customer'),
                        t('search-by-service'),
                        t('search-by-contract'),
                    ]}
                    showFilters={true}
                    className="w-full"
                />
            </div>
        </>
    )
}

export default Search
